<template>
  <v-dialog
    v-if="request"
    :value="value"
    width="640"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>
        申請の却下
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-layout column mb-4>
            <v-flex class="label">代理店名</v-flex>
            <v-flex class="value">{{ request.agencyName }}</v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">マージン率</v-flex>
            <v-flex class="value"
              ><AppPercent :value="request.marginValue"
            /></v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">使用可能期間</v-flex>
            <v-flex class="value">
              <AppPeriod
                :start="request.startDate"
                :end="request.endDate"
                is-date
              />
            </v-flex>
          </v-layout>
          <v-layout column mb-4>
            <v-flex class="label">却下理由（必須）</v-flex>
            <v-flex>
              <v-textarea v-model="reason" />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="!isValid" color="primary" @click="reject">却下</v-btn>
        <v-btn color="primary" @click="close">キャンセル</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { actions } from '@/vuex/modules/admin/request/agencyMargin/constants'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'RejectModal',
  props: {
    value: Boolean,
    request: Object,
  },
  data() {
    return {
      reason: '',
    }
  },
  computed: {
    isValid() {
      return this.reason.length > 0
    },
  },
  methods: {
    async reject() {
      const item = this.request
      const reason = this.reason
      try {
        await this.$store.dispatch(actions.REJECT_ITEM, { item, reason })
        this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '却下しました',
        })
        this.$store.dispatch(actions.SEARCH)
        this.close()
      } catch (e) {
        throw e
      }
    },
    close() {
      this.reason = ''
      this.$emit('input', false)
    },
  },
}
</script>

<style scoped lang="scss">
.label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.value {
  font-size: 16px;
}
</style>
